// extracted by mini-css-extract-plugin
module.exports = {"icon-search":"_3tn8iT _34RNph"};